// Pure helpers for syncing the floating-button timer with /api/timer/.
// The server row is the source of truth; see hooks/useTimerSync.js.

// Fired on window by usePermissionsWebSocket when the server pushes timer_changed.
export const TIMER_CHANGED_EVENT = 'running-timer-changed';

// JSON with sorted keys, so two equal forms always compare equal.
export const stableStringify = (value) => {
  if (Array.isArray(value)) return `[${value.map(stableStringify).join(',')}]`;
  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort()
      .map((k) => `${JSON.stringify(k)}:${stableStringify(value[k])}`)
      .join(',')}}`;
  }
  return JSON.stringify(value === undefined ? null : value);
};

export const formSnapshot = (formData, teamspaceId) => stableStringify({
  form: formData || {},
  teamspace: teamspaceId == null ? null : String(teamspaceId),
});

/**
 * What this tab should do with the server's timer.
 * local: { running, version } — version is null until the server has accepted this tab's timer.
 *   'apply'      adopt the server's timer (started or edited elsewhere, or a newer version)
 *   'stop'       it was stopped elsewhere
 *   'push-start' this tab started it while the server was unreachable — send it now
 *   'none'       already in sync
 */
export const reconcileTimer = (local, server) => {
  if (!server) {
    if (!local.running) return 'none';
    return local.version == null ? 'push-start' : 'stop';
  }
  if (local.running && local.version === server.version) return 'none';
  return 'apply';
};
